
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/organisations/[...slug]",
      function () {
        return require("private-next-pages/organisations/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/organisations/[...slug]"])
      });
    }
  